<template>
  <div class="setting-userinfo">
    <ul class="setting-userinfo-tab-container module-item-style" >
<!--      v-if="tabbar.length > 0"-->
      <router-link :to="menu.path" tag="li" v-for="(menu, index) in tabbar" :class="$route.path == menu.path ? 'tabActived' : ''" :key="index">{{menu.meta.title}}</router-link>
    </ul>
    <div class="setting-userinfo-content-container module-item-style">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-userinfo',
    data() {
      return {
        imageUrl: '',


      }
    },
    computed:{
      tabbar(){
        let menu = []
        let currenMenuMatched = this.$route.matched
        this.$store.state.permission.addRoutes.map((item) => {
          if(item.name == 'layout'){
            item.children.map( subItem => {
              if(subItem.path == currenMenuMatched[1].path){
                subItem.children.map( subSubItem => {
                  if(subSubItem.path == currenMenuMatched[2].path){
                    subSubItem.children.map( subSunSubItem => {
                      if(subSunSubItem.path == currenMenuMatched[3].path){
                        menu = subSunSubItem.children
                      }
                    })
                  }
                })
              }
            })
          }
        })
        return menu
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
  .setting-userinfo {
    .setting-userinfo-tab-container {
      display: flex;
      padding: 24px 24px 17px;

      li {
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }
    }

    .setting-userinfo-content-container {
      margin-top: 10px;
      padding: 22px;
    }
  }
</style>
